// src/components/Sidebar.jsx
import React, { useState, useEffect } from 'react';
import '../styles/Sidebar.css';

const Sidebar = ({ collapsed, setCollapsed, setPage, user }) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [open, setOpen] = useState(!isMobile);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      setOpen(!mobile);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleToggle = () => {
    if (isMobile) setOpen(!open);
    else setCollapsed(!collapsed);
  };

  const handleNavigation = (page) => {
    setPage(page);
    if (isMobile) setOpen(false);
  };

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''} ${open ? 'open' : ''}`}>
      <div className="toggle-wrapper">
        <button className="toggle-btn" onClick={handleToggle}>
          {isMobile ? (open ? '✕' : '☰') : collapsed ? '>' : '<'}
        </button>
      </div>

      {open && (
        <ul className="nav-links">
          <li>
            <button className="nav-link" onClick={() => handleNavigation('home')}>
              <span className="icon">🧬</span>
              {!collapsed && <span>Pharma</span>}
            </button>
          </li>
          <li>
            <button className="nav-link" onClick={() => handleNavigation('manufacturing')}>
              <span className="icon">🏗️</span>
              {!collapsed && <span>Manufacturing</span>}
            </button>
          </li>
          <li>
            <button className="nav-link" onClick={() => handleNavigation('powerplant')}>
              <span className="icon">🏭</span>
              {!collapsed && <span>PowerPlant</span>}
            </button>
          </li>
          <li>
            <button className="nav-link" onClick={() => handleNavigation('dashboard')}>
              <span className="icon">📊</span>
              {!collapsed && <span>Dashboard</span>}
            </button>
          </li>
          <li>
            <button className="nav-link" onClick={() => handleNavigation('about')}>
              <span className="icon">ℹ️</span>
              {!collapsed && <span>About</span>}
            </button>
          </li>

          {/* Login / Profile */}
          <li>
            <button
              className="nav-link"
              onClick={() => handleNavigation(user ? 'profile' : 'login')}
            >
              <span className="icon">{user ? '👤' : '🔐'}</span>
              {!collapsed && <span>{user ? user.username : 'Login'}</span>}
            </button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default Sidebar;
